import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { VisualizadorService } from '../service/visualizador.service';
import { Constantes } from '../constant/constantes';
import { MegaMenuComponent } from '../../home/public/mega-menu/mega-menu.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: true,
    imports: [MegaMenuComponent, RouterModule]
})
export class HeaderComponent implements OnInit {

  public constante: Constantes = new Constantes();
  public urlBuscador!: string;
  public urlGraficador!: string;
  public urlIndicadorEconomicoDia!: string;
  public urlHistorico!: string;

  constructor(private router: Router, private service: VisualizadorService) { }

  ngOnInit(): void {
    this.consultarURLGraficador();
    this.consultarURLBuscador();
    this.consultarURLIndicadorEconomicoDia();
    this.consultarURLHistorico();
  }

  public abrirPagina(opcion: string, tipo: string) {
    var ulrEnlace: string = '';
    if ('INTERNO' === tipo) {
      this.router.navigate([opcion]);
    } else {
      if ('graficador' === opcion) {
        ulrEnlace = this.urlGraficador;
      } else if ('shopping' === opcion) {
        ulrEnlace = this.urlBuscador;
      } else if ('audiorespuesta' === opcion) {
        ulrEnlace = this.urlIndicadorEconomicoDia;
      } else if ('historico' === opcion) {
        ulrEnlace = this.urlHistorico;
      }
      this.service.windowOpen(ulrEnlace, '_blank');
    }
  }

  private consultarURLHistorico() {
    this.service.consultaParametro(this.constante.PROPIEDAD_URL_SERIE_HITORICO).subscribe({
      next: (data) => {
        this.urlHistorico = data;
      },
      error: (error) => {
        console.log("Error inesperado en consultaParametro", error);
      }
    });
  }

  private consultarURLGraficador() {
    this.service.consultaParametro(this.constante.PROPIEDAD_URL_GRAFICADOR).subscribe({
      next: (data) => {
        this.urlGraficador = data;
      },
      error: (error) => {
        console.log("Error inesperado en consultaParametro", error);
      }
    });
  }

  private consultarURLBuscador() {
    this.service.consultaParametro(this.constante.PROPIEDAD_URL_BUSCADOR).subscribe({
      next: (data) => {
        this.urlBuscador = data;
      },
      error: (error) => {
        console.log("Error inesperado en consultaParametro", error);
      }
    });
  }

  private consultarURLIndicadorEconomicoDia() {
    this.service.consultaParametro(this.constante.PROPIEDAD_URL_INDICADOR_ECONOMICO_DIA).subscribe({
      next: (data) => {
        this.urlIndicadorEconomicoDia = data;
      },
      error: (error) => {
        console.log("Error inesperado en consultaParametro", error);
      }
    });
  }
}